var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9997 13.9999V19.9999M17.9997 25.9999H18.0147M32.5946 27.4998L20.5946 6.49985C20.333 6.03816 19.9536 5.65413 19.495 5.38695C19.0365 5.11977 18.5153 4.979 17.9846 4.979C17.454 4.979 16.9328 5.11977 16.4743 5.38695C16.0157 5.65413 15.6363 6.03816 15.3747 6.49985L3.37465 27.4998C3.11017 27.9579 2.97149 28.4777 2.97266 29.0066C2.97383 29.5355 3.11482 30.0547 3.38132 30.5116C3.64782 30.9684 4.03037 31.3467 4.49019 31.6081C4.95001 31.8695 5.47076 32.0046 5.99965 31.9998H29.9997C30.526 31.9993 31.0429 31.8603 31.4986 31.5968C31.9542 31.3332 32.3325 30.9545 32.5954 30.4985C32.8584 30.0426 32.9967 29.5254 32.9966 28.9991C32.9964 28.4727 32.8578 27.9557 32.5946 27.4998Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.d4bd98e6310f0709736290a3d3d10595.svg";
export { ForwardRef as ReactComponent };